// react
import { connect } from "react-redux";
import CompareIndicator from "../header/IndicatorCompare";
import Indicator from "../header/Indicator";
import IndicatorAccount from "../header/IndicatorAccount";
import { Heart20Svg,  } from "../../svg";

function FooterMobileSticky(props) {
  const { wishlist } = props;
  return (
    <nav className="sticky-footer-bar" aria-label="Mobile account navigation">
      <div className="bar-item sticky-footer-bar__item">
        <IndicatorAccount mobile={true} index={2} />
        <span className="sticky-footer-bar__label">Account</span>
      </div>
      <div className="bar-item sticky-footer-bar__item">
        <CompareIndicator />
        <span className="sticky-footer-bar__label">Compare</span>
      </div>
      <div className="bar-item sticky-footer-bar__item">
        <Indicator className="sticky-footer-bar__indicator" url="/shop/wishlist" value={wishlist} name1="Wishlist" icon={<Heart20Svg />} />
        <span className="sticky-footer-bar__label">Wishlist</span>
      </div>
    </nav>
  );
}

const mapStateToProps = (state) => ({
  wishlist: state.wishlist.length,
  compare: state.compare.length,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FooterMobileSticky);
